import i18next from "../i18n";

export const careerProfile = {
  sectionTitle: i18next.t("careerProfile.sectionTitle"),
  icon: null,
  description: i18next.t("careerProfile.description"),
};

export default careerProfile;
